export async function submitCreateEditorial(payload: any, trigger: any) {
  if (!payload) return;

  let output;

  const response = await trigger(payload);
  output = {
    message: "success",
    response: response,
  };
  return output;
}

export async function getEditorialById(trigger: any) {
  let output;

  const response = await trigger();
  output = {
    message: "success",
    response: response,
  };
  return output;
}
